module.exports = __webpack_public_path__ + "static/img/newyork.39df742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/newyork.jpg
// module id = Gcho
// module chunks = 1